import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlame = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 12",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "nonzero",
		fill: "none",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M4.252 11c-.614-1.387-.287-2.181.185-2.93.517-.82.65-1.632.65-1.632s.406.574.244 1.47c.718-.867.853-2.249.745-2.778C7.698 6.36 8.392 9.025 7.457 11c4.97-3.052 1.236-7.619.586-8.133.217.514.258 1.385-.18 1.808C7.123 1.625 5.29 1 5.29 1c.217 1.573-.785 3.292-1.752 4.577-.034-.627-.07-1.06-.374-1.66-.068 1.14-.87 2.068-1.087 3.21-.294 1.546.22 2.677 2.175 3.873z",
			fill: "#FE5800"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M4.3 11.014c-.475-.194-.94-.815-.8-2.014.093-.8.593-1.8 1.5-3 .15.153.25.32.3.5.078.28.145.614.2 1 .255-.552.422-1.052.5-1.5a4.807 4.807 0 0 0 0-1.5c.723.963 1.223 1.796 1.5 2.5.277.704.444 1.565.5 2.584 0 .597-.167 1.063-.5 1.396-1.28.523-2.725.228-3.2.034z",
			fill: "#FBC942"
		})]
	})
});
export default SvgFlame;
